import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { Observable } from 'rxjs';
import { noop } from 'lodash';

export class NotificationIconTypes {
    public static readonly routerLink = 'routerLink';
    public static readonly link = 'link';
    public static readonly button = 'button';
}

@Component({
    selector: 'notification-icon',
    template: require('./notification-icon.component.html'),
    styles: [require('./notification-icon.component.scss')],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class NotificationIconComponent {
    @Input()
    public totalCount: Observable<number> = null;

    @Input()
    public icon: string = null;

    @Input()
    public iconClassName: string = null;

    @Input()
    public onIconClick: (e: Event) => void = noop;

    @Input()
    public tooltipText: string;

    @Input()
    public url: string[];

    @Input()
    public showCounter: boolean;

    @Input()
    public hrefUrl: string;

    @Input()
    public shouldOpenInNewTab: boolean;

    @Input()
    public disabled = true;

    @Input()
    public iconType: string = NotificationIconTypes.routerLink;

    public queryParams: Observable<Params>;
    public notificationIconTypes = NotificationIconTypes;

    constructor(route: ActivatedRoute) {
        this.queryParams = route.queryParams;
    }
}